<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('notifications.editNotification') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="notification-edit-form" tag="form">
          <div class="form-group">
            <label for="description">
              {{ $t('notifications.form.description') }}:
            </label>

            <validation-provider
              rules="required"
              name="description"
              v-slot="{ errors }">
              <d-textarea
                v-model="description"
                :value.prop="description"
                :state="errors.length ? 'invalid' : null"
                :rows="5" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <d-row>
            <d-col cols="6">
              <div class="form-group">
                <label for="name">
                  {{ $t('notifications.form.date') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="date"
                  v-slot="{ errors }">
                  <d-datepicker
                    v-model="date"
                    :monday-first="true"
                    format="yyyy-MM-dd"
                    :placeholder="$t('ui.chooseDate')"
                    :disabled-dates="pastDates"
                    :language="translationsForDatePicker" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="6">
              <div class="form-group">
                <label for="name">
                  {{ $t('notifications.form.time') }}:
                </label>

                <div class="d-flex align-middle">
                  <d-form-select
                    v-model="timeHours"
                    class="mr-2">
                    <option
                      v-for="(hour, index) of hoursList"
                      :key="'time-hour-' + index"
                      :value="hour">
                      {{ hour }}
                    </option>
                  </d-form-select>

                  <span style="line-height: 30px;">:</span>

                  <d-form-select
                    v-model="timeMinutes"
                    class="ml-2">
                    <option
                      v-for="(minute, index) of minutesList"
                      :key="'time-minute-' + index"
                      :value="minute">
                      {{ minute }}
                    </option>
                  </d-form-select>
                </div>
              </div>
            </d-col>
          </d-row>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        <i class="material-icons">add</i>
        {{ $t('notifications.editNotification') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import datepickerTranslations from './../../data/datepicker-translations.js';
import FormUtils from './../../utils/FormUtils.js';
import getPrefferedLanguage from './../../utils/i18nUtils.js';

export default {
  name: 'contact-notification-new-popup',
  props: {
    notificationData: {
      required: true
    }
  },
  computed: {
    hoursList () {
      return Array.from({ length: 24 }, (v, k) => k < 10 ? '0' + k : (k).toString());
    },
    minutesList () {
      return Array.from({ length: 60 }, (v, k) => k < 10 ? '0' + k : (k).toString());
    },
    translationsForDatePicker () {
      return datepickerTranslations[getPrefferedLanguage()];
    },
    pastDates () {
      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      return {
        to: yesterday
      };
    }
  },
  data () {
    return {
      description: '',
      date: new Date(),
      timeHours: '00',
      timeMinutes: '00'
    };
  },
  beforeMount () {
    if (this.notificationData.id) {
      this.description = this.notificationData.description;
      this.date = new Date(this.notificationData.date);
      let time = this.notificationData.time.split(':');
      this.timeHours = (parseInt(time[0], 10) < 10 ? '0' + parseInt(time[0], 10) : time[0]).toString();
      this.timeMinutes = (parseInt(time[1], 10) < 10 ? '0' + parseInt(time[1], 10) : time[1]).toString();
    }
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['notification-edit-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/notifications/update/' + parseInt(this.notificationData.id, 10),
        formData: this.prepareFormData(),
        successTitle: this.$t('notifications.form.editNotificationSuccessTitle'),
        successText: this.$t('notifications.form.editNotificationSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('notifications.form.editNotificationErrorText'),
        successAction: () => {
          this.$bus.$emit('contact-notifications-reload-needed');
          this.handleClose();
        }
      });
    },
    prepareFormData () {
      let formData = {
        description: this.description,
        date: [this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate()].map(n => n < 10 ? '0' + n : n).join('-'),
        time: [this.timeHours, this.timeMinutes].join(':'),
        show_in_dashboard: 0,
        send_reminder: 1,
        reminder_before: 0
      };

      return formData;
    },
    handleClose () {
      this.$bus.$emit('contact-notifications-close-edit-popup');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
